import {
    Accordion,
    BasicCollapsible,
    BoundedContent,
    Box,
    Column,
    GridContainer,
    H3,
    Row,
    tokens,
} from '@vp/swan';
import { decode } from 'html-entities';
import styled from 'styled-components';
import { __ } from '@99designs/i18n';
import { ServiceDetailsPageDataQuery } from '../../graphql';

export interface FAQSectionProps {
    faqs: ServiceDetailsPageDataQuery['serviceDetailPage']['faqs'];
}

const Answer = styled.div`
    p {
        margin-bottom: ${tokens.SwanSemSpace7};
    }
`;

export function FAQSection({ faqs }: FAQSectionProps) {
    if (!faqs || faqs.length === 0) {
        return null;
    }

    return (
        <BoundedContent bgc="warm-white" paddingTop={9} paddingBottom={9}>
            <GridContainer>
                <Row>
                    <Column span={4}>
                        <Box>
                            <H3 fontSkin="title-section">{__('Frequently Asked Questions')}</H3>
                        </Box>
                    </Column>
                    <Column span={8}>
                        <Box>
                            <Accordion single>
                                {faqs.map((faq) => (
                                    <BasicCollapsible
                                        key={faq.question}
                                        collapsibleId={faq.question}
                                        heading={faq.question}
                                        headingLevel="h4"
                                    >
                                        <Answer
                                            dangerouslySetInnerHTML={{
                                                __html: decode(faq.answerHtml),
                                            }}
                                        />
                                    </BasicCollapsible>
                                ))}
                            </Accordion>
                        </Box>
                    </Column>
                </Row>
            </GridContainer>
        </BoundedContent>
    );
}
